import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Authenticated } from "react-admin";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Title } from "react-admin";
import { Helmet } from "react-helmet";
import "./dashboard.scss";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import DashboardCustomerService from "./component/DashboardCustomerService";
import DashboardOperation from "./component/DashboardOperation";
import DashboardFinance from "./component/DashboardFinance";

const Dashboard = ({ location }: any) => {
  const navMode = useSelector((state: any) => state.navMode.mode);

  const renderDashboard = (navMode: string) => {
    switch (navMode) {
      case "CUSTOMER_SERVICE":
        return <DashboardCustomerService />;

      case "OPERATION":
        return <DashboardOperation />;

      case "FINANCE":
        return <DashboardFinance />;

      default:
        return (
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Dashboard
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              this page is under construction...
            </Typography>
          </CardContent>
        );
    }
  };

  return (
    <Authenticated location={location}>
      {navMode === "FINANCE" ? (
        <div>
          <div>
            <Helmet>
              <title>Dashboard</title>
            </Helmet>
            <Title title="Dashboard" />
            {renderDashboard(navMode)}
          </div>
        </div>
      ) : (
        <div>
          <Card className="Dashboard">
            <Helmet>
              <title>Dashboard</title>
            </Helmet>
            <Title title="Dashboard" />
            {renderDashboard(navMode)}
          </Card>
        </div>
      )}
    </Authenticated>
  );
};

export default withRouter(Dashboard);
